module.exports = __webpack_public_path__ + "img/1.12cae121.png";